"use client";

import { c as _c } from "react/compiler-runtime";
import { toLowerCase } from "@opensea/utils";
import { createContext, useContext } from "react";
import { getMarketplaceLogo } from "./marketplace-logos";
const MarketsContext = createContext({
  markets: []
});
export function MarketsProvider(t0) {
  const $ = _c(5);
  const {
    markets,
    children
  } = t0;
  let t1;
  if ($[0] !== markets) {
    t1 = {
      markets
    };
    $[0] = markets;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const value = t1;
  let t2;
  if ($[2] !== children || $[3] !== value) {
    t2 = <MarketsContext.Provider value={value}>{children}</MarketsContext.Provider>;
    $[2] = children;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export const useMarkets = () => {
  const $ = _c(7);
  const {
    markets
  } = useContext(MarketsContext);
  let t0;
  if ($[0] !== markets) {
    t0 = markets.reduce(_temp, {});
    $[0] = markets;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const marketByIdentifier = t0;
  let t1;
  if ($[2] !== marketByIdentifier) {
    t1 = identifier => marketByIdentifier[toLowerCase(identifier)]?.name || "Unknown";
    $[2] = marketByIdentifier;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getMarketName = t1;
  const getLogo = _temp2;
  let t2;
  if ($[4] !== getMarketName || $[5] !== markets) {
    t2 = {
      markets,
      getMarketName,
      getLogo
    };
    $[4] = getMarketName;
    $[5] = markets;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export { MarketsContext };
function _temp(acc, curr) {
  acc[curr.identifier] = curr;
  return acc;
}
function _temp2(identifier_0) {
  return getMarketplaceLogo(identifier_0);
}